import classNames from "classnames";
import React from "react";
import styles from "../FormField.module.scss";

export interface IPhoneFormFieldProps {
  id?: string;
  error?: string;
  name?: string;
  readOnly?: boolean;
  registerField?: any;
  isFocused?: boolean;
  isRequired?: boolean;
  maskPlaceholder?: string;
  autoComplete?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  checksPresenceName?: (
    e: React.ChangeEvent<HTMLInputElement> | React.FocusEvent<HTMLElement>,
    name: string,
  ) => void;
}

export const PhoneFormField: React.FC<IPhoneFormFieldProps> = ({
  id,
  error,
  name,
  registerField,
  isFocused,
  maskPlaceholder,
  onFocus,
  onBlur,
  checksPresenceName,
  readOnly = false,
  autoComplete,
}) => {
  const PATTERN = /\D/g;

  const getInputNumbersValue = (value: string) => {
    return value.replace(PATTERN, "");
  };

  const handlePhoneInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (checksPresenceName) {
      checksPresenceName(e, name);
    }
    const input = e.target;
    let inputNumbersValue = getInputNumbersValue(input.value);
    let formattedInputValue = "";
    const selectionStart = input.selectionStart;

    if (!inputNumbersValue) {
      return (input.value = "");
    }

    if (input.value.length !== selectionStart) {
      return;
    }

    if (inputNumbersValue?.trim()?.length >= 1 && maskPlaceholder) {
      inputNumbersValue = maskPlaceholder + inputNumbersValue.slice(1);
    }

    if (["7", "8", "9"].includes(inputNumbersValue[0])) {
      // Русский формат телефона
      if (inputNumbersValue[0] === "9") {
        inputNumbersValue = "7" + inputNumbersValue;
      }

      const firstSymbols = inputNumbersValue[0] === "8" ? "8" : "+7";
      formattedInputValue = firstSymbols + " ";

      if (inputNumbersValue.length > 1) {
        formattedInputValue += "(" + inputNumbersValue.substring(1, 4);
      }
      if (inputNumbersValue.length >= 5) {
        formattedInputValue += ") " + inputNumbersValue.substring(4, 7);
      }
      if (inputNumbersValue.length >= 8) {
        formattedInputValue += "-" + inputNumbersValue.substring(7, 9);
      }
      if (inputNumbersValue.length >= 10) {
        formattedInputValue += "-" + inputNumbersValue.substring(9, 11);
      }
    } else {
      // Не русский формат телефона
      formattedInputValue = "+" + inputNumbersValue.substring(0, 16);
    }

    input.value = formattedInputValue;
  };

  const handlePhoneKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const input = e.target as HTMLInputElement;
    if (
      e.key === "Backspace" &&
      getInputNumbersValue(input.value).length === 1
    ) {
      input.value = " ";
    }
    return input;
  };

  const handlePhonePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData ?? window["clipboardData"];
    const input = e.target as HTMLInputElement;
    const inputNumbersValue = getInputNumbersValue(input.value);

    if (pasted) {
      const pastedText = pasted.getData("Text");
      if (PATTERN.test(pastedText)) {
        input.value = inputNumbersValue;
      }
    }
  };

  return (
    <input
      {...registerField}
      id={id}
      className={classNames(styles.input, {
        [styles.error]: error,
        [styles.active]: isFocused,
      })}
      name={name}
      type="tel"
      readOnly={readOnly}
      onInput={handlePhoneInput}
      onKeyDown={handlePhoneKeyDown}
      onPaste={handlePhonePaste}
      onFocus={onFocus}
      onBlur={onBlur}
      autoComplete={autoComplete}
    />
  );
};
